import {Directive} from '@angular/core';
import {AbstractControl, NG_VALIDATORS, Validator} from '@angular/forms';
import {createStaticValidator} from './common';

const UppercasePattern = /[A-Z]/;
export const Uppercase = createStaticValidator((control: AbstractControl) => UppercasePattern.test(control.value), {
  uppercase: true,
});

@Directive({
  selector: '[numeric]',
  providers: [{provide: NG_VALIDATORS, useExisting: UppercaseDirective, multi: true}],
})
export class UppercaseDirective implements Validator {
  validate = Uppercase;
}



// WEBPACK FOOTER //
// ./src/app/shared/validators/uppercase.validator.ts